
import { usePaymnetContext } from "..";
import JSEncrypt from 'jsencrypt';
export interface IStep {
    id: number;
    active: boolean;
}

export interface IPaymentPartner {
    id: string;
    paymentAcknowledgmentRoute: string;
    logoUrl: string;
    partnerName: string;
    partnerType?: string;
    source?: string;
    provider: string;
    currency: string
    isMno?: boolean;
    paymentPartnerId?: string;
    paymentVendorId?: string;
    vendorName?: string;
    status?: string;
    vendorType?: string;
}

export const PHONE_STATUS = {
    PHONE_REQUIRED: 'PHONE_REQUIRED',
    PHONE_VERIFY: 'PHONE_VERIFY',
    PHONE_NOT_REGISTER: 'PHONE_NOT_REGISTER',
    PENDING: "PENDING",
    CONFIRMATION_INPROGERSS: "CONFIRMATION_INPROGERSS",
    CONFIRMED: "CONFIRMED",
    INVALID_PIN: "INVALID_PIN"
}

export const useSystemMessage = (show: boolean) => {
    const { state, update } = usePaymnetContext();
    update({
        ...state,
        systemMessage: {
            ...state.systemMessage,
            show: true
        }
    })
}

export const getQueryStringValue = (key: string) => {
    const params = new URLSearchParams(window.location.search)
    const value: string | null = params.get(key);
    return value;
}

export const generateUUID = () => {
    let
        d = new Date().getTime(),
        d2 = (performance && performance.now && (performance.now() * 1000)) || 0;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        let r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c == 'x' ? r : (r & 0x7 | 0x8)).toString(16);
    });
};

export const PREVIEW_MODE = "preview";
export const encryptStringWithRsaPublicKey = (toEncrypt: any, publicKey: string) => {
    var encrypt = new JSEncrypt();
    encrypt.setPublicKey(publicKey);
    return encrypt.encrypt(toEncrypt);
}